/**
* Created by kongwm.kong on 2017/7/28.
*/
<template>
    <div class="uploadBox">
        <form role="form" enctype="multipart/form-data" >
            <label  :class="['label-for-file',{'whiteColor': whiteColor}]" for="upload-file">{{labelText}}</label>
            <input type="file" name="image"   id="upload-file" class="input-file" @change="onChange">
        </form>
        <div class="text-msg">{{msgTip}}</div>
        <div class="err-wrap">
            <!--<span class="err" v-show="errors.has('image') && !showSizeMsg">{{errors.first('image')}}</span>-->
            <span class="err">{{showSizeMsgText}}</span>
        </div>
    </div>
</template>

<script>
//    require('es6-promise').polyfill();
//    import axios from 'axios';

//    component: {axios}
    export default {
        props: {
            postURL: {
                type: String,
                default: '/account/promiseFile'
            },
            isExcel:{ // 导入净值
                type: Boolean,
                default: false
            },
            postType:{
                type: String,
                default: ''
            },
            minItems: {
                type: Number,
                default: 1
            },
            maxItems: {
                type: Number,
                default: 30
            },
            method: {
                type: String,
                default: 'post'
            },
            color: {
                type: String,
                default: '#fff'
            },
            postMeta: {
                type: [String, Array, Object],
                default: ''
            },
            successMessage: {
                type: String,
                default: ''
            },
            errorMessage: {
                type: String,
                default: '已上传承诺函'
            },
            labelText:{
                type: String,
                default: '上传承诺函'
            },
            isValidSize: {
                type: Boolean,
                default: true
            },
            fileByteSize:{
                type: Number,
                default: 5
            }
        },

        /*
         * The component's data.
         */
        data() {
            return {
                msgTip: '',
                items: [],
                itemsAdded: '',
                itemsNames: [],
                itemsSizes: [],
                itemsTotalSize: '',
                formData: '',
                successMsg: '',
                errorMsg: '',
                isLoaderVisible: false,
                whiteColor: false,
                showSizeMsg: false,
                showSizeMsgText: '',
                isValidSizeFlag : this.isValidSize,    //是否验证大小
            }
        },
        created(){
            if(this.color.indexOf('408')>-1){
                this.whiteColor = false;
            } else {
                this.whiteColor = true;
            }
        },
        mounted(){
            if(this.color.indexOf('408')>-1){
                this.whiteColor = false;
            } else {
                this.whiteColor = true;
            }
//            console.log(this.isValidSizeFlag);
        },
        methods: {
            // http://scratch99.com/web-development/javascript/convert-bytes-to-mb-kb/
            bytesToSize(bytes) {
                const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
                if (bytes === 0) return 'n/a';
                let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
                if (i === 0) return bytes + ' ' + sizes[i];
                return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
            },
            validFileSize(bytes){
//                console.log(bytes);
                let size = this.fileByteSize *1024 * 1024;
                return bytes <= size;
            },
            onChange(e) {
                this.removeItems();
                this.successMsg = '';
                this.errorMsg = '';
                this.formData = new FormData();
                let files = e.target.files || e.dataTransfer.files;
                this.itemsAdded = files.length;
                let fileSizes = 0;
                this.showSizeMsgText ='';
                for (let x =0; x< this.itemsAdded ; x++) {
                    if (x===0) {
                        this.items = e.target.files[x] || e.dataTransfer.files[x];
                        this.itemsNames[x] = files[x].name;
                        this.itemsSizes[x] = this.bytesToSize(files[x].size);
                        let sizeFlag = this.validFileSize(files[x].size);
                        if(!sizeFlag){  //
                            this.showSizeMsgText = '尊敬的用户，您上传的产品承诺函大小超过5MB，请重新上传。';
                            return false;
                        }
                        fileSizes += files[x].size;
                        this.formData.append('file', this.items);
                        if(this.postType !=''){
                            this.formData.append('type', this.postType);
                        }

                        if(!this.isExcel){
                            this.validImg(this.items);
                        } else {
                            this.onSubmit();
                        }
                        break;
                    }
                }
                this.itemsTotalSize = this.bytesToSize(fileSizes);
            },
            validImg(item){
                if(!/\.(jpg|jpeg|png|JPEG|JPG|PNG)$/.test(item.name)) {
                    this.showSizeMsgText = '尊敬的用户，您上传的产品承诺函格式有误，仅支持jpg、jpeg、png格式，请重新上传。';
                    return false;
                }else {
                    this.showSizeMsgText = '';
                }
                //读取图片数据
                var that = this;
                var reader = new FileReader();
                reader.onload = function (e) {
                    var data = e.target.result;
                    if(that.isValidSizeFlag){
                        //加载图片获取图片真实宽度和高度
                          var image = new Image();
                          image.onload=function(){
                              let width = image.width;
                              let height = image.height;
                              that.showSizeMsg = (width >= 480 || height >= 480);
                              if(!that.showSizeMsg){
                                  that.onSubmit();
                                  that.showSizeMsgText = '';
                                  that.$emit('previewImg', data );
                              } else {
                                  that.showSizeMsgText = '支持480*480以下图片大小';
                              }
                          };
                          image.src= data;
                    } else {
                        that.$emit('previewImg', data);
                        that.onSubmit();
                    }
                };
                reader.readAsDataURL(item);
            },
            removeItems() {
                this.items = '';
                this.itemsAdded = '';
                this.itemsNames = [];
                this.itemsSizes = [];
                this.itemsTotalSize = '';
            },
            onSubmit() {
                this.isLoaderVisible = true;
                if ((typeof this.postMeta === 'string' && this.postMeta !== '') ||
                    (typeof this.postMeta === 'object' && Object.keys(this.postMeta).length > 0)) {
                    this.formData.append('postMeta', this.postMeta);
                }
                if (this.method === 'put' || this.method === 'post' ) {
                    this.showSizeMsgText = '';
                    this.msgTip = '正在上传，请稍候...';
                    this.$http.request({
                            method: this.method,
                            url: this.postURL,
                            data: this.formData
                        },(response) => {
                            this.msgTip = '';
                            this.isLoaderVisible = false;
                            this.removeItems();
                            if(response.data.code ==200){
                                this.$emit('showSmallImg', response.data.data);
                                this.showSizeMsgText = ''
                                if(this.successMessage !='' && this.successMessage ){
                                    this.$store.commit('msg', this.successMessage);
                                }
                            }else if(response.data.code ==401){
                                this.showSizeMsgText = this.errorMessage;
                            } else {
                                this.showSizeMsgText = '服务器繁忙';
                            }
                        },(error) => {
                            this.isLoaderVisible = false;
                            this.errorMsg = error + "." + this.errorMessage;
                            this.removeItems();
                        });
                } else {
                    this.errorMsg = "This HTTP method is not allowed. Please use either 'put' or 'post' methods.";
                }
                this.removeItems();
            },
        }
    }
</script>

<style type="text/scss" lang="scss" scoped>
    .uploadBox {
        position: relative;
        font-weight:bold;
        font-size: 18px;
        letter-spacing: -0.43px;
        .err-wrap,.text-msg{
            position: absolute;
            top:120%;
            left:0;
            width: 350px;
        }
        .text-msg{
            top:122%;
            font-size: 14px;
            font-weight: normal;
        }
    }
    .uploadBox .label-for-file {
        cursor: pointer;
        color:$btn_408;
        z-index: 2;
        position: relative;
        &.whiteColor{
            color:#fff;
        }
    }
    .uploadBox .err{
        font-weight:normal;
        width: 700px;
        display: inline-block;
    }
    .uploadBox .input-file {
        position: absolute;
        cursor: pointer;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        filter: alpha(opacity=0);
        z-index: 1;
    }

</style>


// WEBPACK FOOTER //
// src/components/common/upload.vue